/**
 * Wheel container
 */
import classnames from 'classnames';
import forEach from 'lodash/forEach';
import Modernizr from 'modernizr';
import React, { Component, PropTypes } from 'react';
import WheelLabel from './WheelLabel';
import PieSlice from './PieSlice';
import WheelComponent from './WheelComponent';

require('./scss/wheel.scss');

class Wheel extends Component {

  constructor(props) {
    super(props);
    const { wheelAspects } = this.props;
    this.state = {
      wheelAspects,
      hoveredAspect: null,
      pieSlices: [],
    };
    this.setHoveredAspect = this.setHoveredAspect.bind(this);
    this.getPieSlices = this.getPieSlices.bind(this);
  }

  /**
   * Set the hovered aspect since we're hovering multiple elements and a straight
   * up css hover won't work.
   */
  setHoveredAspect(hoveredAspect) {
    const { isAnimating } = this.state;
    if (!isAnimating) {
      this.setState({
        hoveredAspect,
      });
    }
  }

  /**
   * Return an ordered array of pie slices. Since we're using svgs and can't
   * stack things with z-index, the top item needs to be moved to the end of the
   * array for animations.
   */
  getPieSlices() {
    const { wheelAspects, activeEntity } = this.state;
    const pieClasses = {
      'background-circle': true,
    };
    let activePieSlice;
    let pieCount = 0;
    if (activeEntity) {
      const shortName = wheelAspects[activeEntity].shortName;
      pieClasses[`active-${shortName.toLowerCase()}`] = true;
    }
    const pieSlices = [
      <circle
        className={classnames(pieClasses)}
        cx="250"
        cy="250"
        r="250"
        key="background-circle"
      />,
    ];
    forEach(wheelAspects, (aspect, entityId) => {
      const theSlice = (
        <PieSlice
          activeEntity={activeEntity}
          aspect={aspect}
          entityId={entityId}
          hoveredAspect={this.state.hoveredAspect}
          index={pieCount}
          key={`pie-slice-${entityId}`}
          matrixTransform={Wheel.getMatrixTransform(pieCount)}
          setAspect={this.setAspect}
          setHoveredAspect={this.setHoveredAspect}
        />
      );
      // If not the active entity, add it to the array. If it is the active
      // entity, save it to add to the end of the array.
      if (activeEntity !== entityId) {
        pieSlices.push(theSlice);
      } else {
        activePieSlice = theSlice;
      }
      pieCount += 1;
    });
    if (activePieSlice) pieSlices.push(activePieSlice);
    return pieSlices;
  }

  /**
   * Get the matrix transform for IE. On these elements, IE is requiring a non-
   * CSS transform. I don't know why. SMIL is a good test for identifying these
   * browsers.
   */
  static getMatrixTransform(index) {
    const matrices = [
      'matrix(1,0,0,1,0,0)',
      'matrix(0.5,0.86602,-0.86602,0.5,341.5063509461096,-91.5063509461097)',
      'matrix(-0.5,0.86602,-0.86602,-0.5,591.5063509461097,158.4936490538905)',
      'matrix(-1,0,0,-1,500,500)',
      'matrix(-0.49999,-0.86602,0.86602,-0.49999,158.49364905389027,591.5063509461096)',
      'matrix(0.5,-0.86602,0.86602,0.5,-91.5063509461097,341.5063509461096)',
    ];
    return Modernizr.smil ? null : matrices[index];
  }

  render() {
    const {
      hoveredAspect,
      wheelAspects,
    } = this.state;
    const listItems = [];
    forEach(wheelAspects, (aspect, entityId) => {
      listItems.push(
        <WheelLabel
          aspect={aspect}
          className={classnames({
            top: (listItems.length < 2),
            middle: (listItems.length === 5 || listItems.length === 2),
            bottom: (listItems.length === 3 || listItems.length === 4),
            left: !(listItems.length > 0 && listItems.length < 4),
            right: (listItems.length > 0 && listItems.length < 4),
          })}
          entityId={entityId}
          hoveredAspect={hoveredAspect}
          setHoveredAspect={this.setHoveredAspect}
        />,
      );
    });
    return (
      <WheelComponent
        hoveredAspect={hoveredAspect}
        listItems={listItems}
        pieSlices={this.getPieSlices}
        wheelAspects={wheelAspects}
      />
    );
  }
}

Wheel.propTypes = {
  wheelAspects: PropTypes.shape({}),
};

export default Wheel;



// WEBPACK FOOTER //
// js/src/wheel/Wheel.js